import React, { useCallback, useMemo } from 'react';
import Accordion from 'components/Accordion';
import useGroupOptions from 'hooks/Meteorology/Agro/CultureIndex/Location/useGroupOptions';
import Searcher from 'components/DesignSystem/Searcher';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useSearchFilter from 'hooks/useSearchFilter';
import Snackbar from 'components/DesignSystem/Snackbar';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function Group() {
  const { availableGroups, selectedGroupId, setGroup } = useGroupOptions();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('culture-index-location-group'), []);
  const setGroupAndClose = useCallback((newGroup : number) => {
    setGroup(newGroup);
    closeAccordion();
  }, [setGroup, closeAccordion]);
  const { searchTerm, onSearchChange, searchIncludes } = useSearchFilter();
  const filteredGroups = useMemo(() => (
    availableGroups?.filter((group) => searchIncludes(group.name))
  ), [availableGroups, searchIncludes]);

  return (
    <Accordion.Item eventKey="group" id="culture-index-location-group">
      <Accordion.Header>Grupo</Accordion.Header>
      <Accordion.Body>
        <Searcher
          value={searchTerm}
          onChange={onSearchChange}
        />
        {availableGroups.length === 0 && (
          <Snackbar className="mt-2">
            Nenhum grupo disponível
          </Snackbar>
        )}
        {filteredGroups.map((group) => (
          <RadioButton
            key={group.id}
            label={group.name}
            checked={group.id === selectedGroupId}
            onChange={() => setGroupAndClose(group.id)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
